export const pick = <T extends object>(obj: T, keys: (string | number)[]): T | Partial<T> => {
  const stringKeys = keys.map(String);

  return Object.keys(obj).reduce(
    (acc: Partial<T>, key: string) => (stringKeys.includes(key) ? { ...acc, [key]: obj[key as keyof T] } : acc),
    {},
  );
};
